<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="card-list-heading">
                        <h2 class="text-bold">{{ __('Invoices') }}</h2>

                        <div class="d-flex flex-wrap">
                            <button
                                @click="filter"
                                class="btn btn-md btn-primary mr-3"
                                type="button"
                            >
                                {{ __('Filter') }}
                            </button>

                            <button
                                @click="exportInvoices"
                                class="btn btn-md btn-primary"
                                type="button"
                            >
                                {{ __('Export XLS') }}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Date from') }}
                                </span>
                                <DateTimePicker
                                    :placeholder="__('Select date from')"
                                    @change="formatDateFrom"
                                    format="YYYY-MM-DD"
                                    name="invoicedatefrom"
                                    type="date"
                                    v-model="filters.dateFrom"
                                    :max-date="filters.dateTo"
                                    value-type="format"
                                />
                            </div>                 
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Number') }}
                                </span>
                                    <FormInput
                                  
                               
                                    type="text"
                                    v-model="filters.title"
                                ></FormInput>
                                <!-- <Autocomplete
                                    :fetch-callback="$api.autocomplete.invoiceTitles"
                                    :placeholder="__('Select number')"
                                    @selected="(item) => filters.title = item.label"
                                    @input="(item) => filters.title = item.label"
                                    params="title"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> -->
                            </div>

                          
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                               

                            <div class="form-row-flex">
                                <span>
                                    {{ __('Date to') }}
                                </span>
                                <DateTimePicker
                                    :placeholder="__('Select date to')"
                                    @change="formatDateTo"
                                    format="YYYY-MM-DD"
                                    name="invoicedateto"
                                    type="date"
                                    v-model="filters.dateTo"
                                    :min-date="filters.dateFrom"
                                    value-type="format"
                                />
                            </div>
                              <!-- <div class="form-row-flex">
                                <span>
                                    {{ __('Status') }}
                                </span>
                                <Autocomplete
                                    :fetch-callback="$api.autocomplete.invoiceStates"
                                    :placeholder="__('Select status')"
                                    @selected="(item) => invoice.state = item.value"
                                    @input="(item) => invoice.state = item.value"
                                    params="title"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div> -->
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 card-nopadding">
                            <wi-table
                                :default-params="{ sort: 'createdAt', order: 'desc'}"
                                :disable-search="true"
                                :disableHeader="true"
                                :fetch-callback="fetch"
                                ref="table"

                            >
                                <!-- <wi-table-column field="id" sortable>#</wi-table-column> -->
                                <wi-table-column class="text-nowrap" field="title" sortable>{{ __('Number') }}</wi-table-column>
                                <wi-table-column :render="dateFormat" field="date" sortable>{{ __('Date') }}</wi-table-column>
                                <wi-table-column field="total">{{ __('Amount') }}</wi-table-column>
                                <wi-table-column field="totalTax">{{ __('VAT Amount') }}</wi-table-column>
                                <wi-table-column field="totalIncTax">{{ __('Amount with VAT') }}</wi-table-column>
                                <!-- <wi-table-column field="state">{{ __('Status') }}</wi-table-column> -->
                                <template slot="actions" slot-scope="{ item }">
                                    <button
                                        @click="documentOpen(item)"
                                        class="btn btn-data-action mr-1"
                                    >
                                        {{ __('Preview') }}
                                    </button>
                                </template>
                            </wi-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
import Invoice from '../../models/Invoice'
import moment from 'moment'
import Vue from 'vue'
import { FilterTable } from '@/mixins/FilterTable'

export default {
  name: 'Invoices',

 mixins: [ FilterTable ],

  data () {
    return {
      invoice: new Invoice({})
    }
  },

  methods: {
    documentOpen (item) {
      window.open(`${Vue.axios.defaults.baseURL}${item.path}`, '_blank')
    },

    dateFormat (item) {
      return moment(item.date).format('YYYY-MM-DD')
    },

    formatDateFrom (date) {
      this.invoice.dateFrom = moment(date).format('YYYY-MM-DD')
      return this.invoice.dateFrom
    },

    formatDateTo (date) {
      this.invoice.dateTo = moment(date).format('YYYY-MM-DD')
      return this.invoice.dateTo
    },  

    exportInvoices () {
      return this.$api.invoices.download(this.invoice)
    },

    fetch (params = []) {
      return this.$api.invoices.list(params)
    }
  }
}
</script>
